module.exports = __webpack_public_path__ + "media/images/city/006-shrine-remembrance-e745a36d9ed56aec41f42f6bb8feb5f9.svg";